import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useCreateChannelContext } from '@sendbird/uikit-react/CreateChannel/context';

import { chatParticipantsSelector } from 'domain/chat';
import { userProfileSelector } from 'domain/env';
import { ChatUser } from '../../types';
import UserSelectModal from '../UserSelectModal';

interface Props {
  onCancel: () => void;
}

const CreateChannelModal: React.FC<Props> = ({ onCancel }) => {
  const { formatMessage } = useIntl();
  const { onCreateChannelClick } = useCreateChannelContext();
  const chatUsers = useSelector(chatParticipantsSelector);
  const userProfile = useSelector(userProfileSelector);

  const users: ChatUser[] = chatUsers
    .filter((u: ChatUser) => Boolean(u.userGUID) && u.userGUID !== userProfile.id)
    .toArray();

  const handleSubmit = useCallback(
    async (selectedIds: string[]) => {
      onCreateChannelClick?.({
        users: selectedIds,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        channelType: 'group' as any,
        onClose: onCancel,
      });
    },
    [onCreateChannelClick, onCancel],
  );

  return (
    <UserSelectModal
      title={formatMessage({ id: 'chat.createChannel.title', defaultMessage: 'Create new chat' })}
      submitLabel={formatMessage({ id: 'chat.createChannel.create', defaultMessage: 'Create' })}
      users={users}
      maxSelectable={11}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  );
};

export default CreateChannelModal;
